import { SITE } from "@/constants/testIds";
import { ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/27207261/pexels-photo-27207261.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000";
const LOGO_URL = "/images/logo.png";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid={SITE.hero}
      className="relative isolate flex min-h-[100svh] items-center overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="A fly angler casting on a peaceful Southern Oregon river at golden hour"
        className="absolute inset-0 h-full w-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-evergreen/45 via-brand-evergreen/25 to-brand-evergreen/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-evergreen/55 via-transparent to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-24 pt-40 md:px-10 md:pb-32 md:pt-44">
        <div className="max-w-3xl animate-fade-up">
          <div className="mb-8 flex items-center gap-4">
            <img
              src={LOGO_URL}
              alt="The Spirit of Fishing logo"
              className="h-20 w-20 md:h-24 md:w-24"
            />
            <div className="flex flex-col leading-tight">
              <span className="text-xs uppercase tracking-[0.35em] text-brand-cream/80">
                Southern Oregon · Est. 2012
              </span>
              <span className="font-display text-2xl text-brand-cream/95 md:text-3xl">
                The Spirit of Fishing
              </span>
            </div>
          </div>

          <h1
            data-testid={SITE.heroHeadline}
            className="font-display text-5xl leading-[0.95] text-brand-cream text-shadow-soft sm:text-6xl lg:text-7xl"
          >
            Discover the Spirit{" "}
            <br />
            <span className="italic text-brand-sand">of fly casting</span>
          </h1>

          <p
            data-testid={SITE.heroSubheadline}
            className="mt-7 max-w-xl text-lg leading-relaxed text-brand-cream/90 md:text-xl"
          >
            Learn the art of fly casting through personalized, unhurried
            instruction&mdash;and experience the joy of learning something new.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              data-testid={SITE.heroCta}
              href="#contact"
              className="group inline-flex items-center gap-2 rounded-full bg-brand-cream px-7 py-4 text-sm font-medium tracking-wide text-brand-evergreen transition-all duration-300 hover:bg-brand-sand"
            >
              Request a Session
              <span
                aria-hidden
                className="inline-block translate-x-0 transition-transform group-hover:translate-x-1"
              >
                →
              </span>
            </a>
            <a
              href="#about"
              className="inline-flex items-center gap-2 rounded-full border border-brand-cream/40 px-7 py-4 text-sm font-medium tracking-wide text-brand-cream transition-all duration-300 hover:border-brand-cream hover:bg-brand-cream/10"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>

      <a
        href="#about"
        aria-label="Scroll to about section"
        className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 animate-fade-in items-center gap-2 text-xs uppercase tracking-[0.3em] text-brand-cream/70 transition hover:text-brand-cream md:flex"
      >
        Scroll <ChevronDown className="h-4 w-4 animate-bounce" />
      </a>
    </section>
  );
}
